// src/components/common/Layout/AuthLayout.jsx
import React from 'react';
import { Box, useTheme } from '@mui/material';

const AuthLayout = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: theme.palette.mode === 'dark' 
          ? `linear-gradient(135deg, ${theme.palette.background.default} 0%, #1a1a1a 100%)`
          : `linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      {children}
    </Box>
  );
};

export default AuthLayout;